/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `waiting` - Waiting
 * * `running` - Running
 * * `error` - Error
 * * `done` - Done
 */
export type LongRunningJobStatus = typeof LongRunningJobStatus[keyof typeof LongRunningJobStatus];


export const LongRunningJobStatus = {
  WAITING: 'waiting',
  RUNNING: 'running',
  ERROR: 'error',
  DONE: 'done',
} as const;
